import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

import { KendoSelectFilterComponent } from './kendo-select-filter.component';

@NgModule({
  declarations: [KendoSelectFilterComponent],
  exports: [KendoSelectFilterComponent],
  imports: [CommonModule, DropDownsModule],
})
export class KendoSelectFilterModule {}
